
import { TableCell, TableRow } from "@/components/ui/table";
import { Profile, UserRole } from "@/lib/types/auth";
import { UserRoleSelect } from "./UserRoleSelect";
import { UserStatusToggle } from "./UserStatusToggle";
import { UserDeleteAction } from "./UserDeleteAction";

interface UserTableRowProps {
  user: Profile;
  onRoleChange: (userId: string, newRole: UserRole) => Promise<void>;
  onStatusChange: (userId: string, isActive: boolean) => Promise<void>;
  onDeleteUser: (userId: string) => Promise<void>;
}

export function UserTableRow({ 
  user, 
  onRoleChange, 
  onStatusChange, 
  onDeleteUser 
}: UserTableRowProps) {
  return (
    <TableRow 
      key={user.id} 
      className={`${!user.is_active ? "opacity-70 bg-accent-subtle/10" : "hover:bg-accent-subtle/20"} border-b border-accent-light/20`}
    >
      <TableCell className="font-body">{user.first_name} {user.last_name}</TableCell>
      <TableCell className="font-body">{user.email || '-'}</TableCell>
      <TableCell className="font-body">{user.school_district || '-'}</TableCell>
      <TableCell className="font-body">{user.school || '-'}</TableCell>
      <TableCell className="font-body">{user.position || '-'}</TableCell>
      <TableCell>
        <UserRoleSelect 
          userId={user.id}
          currentRole={user.role}
          onRoleChange={onRoleChange}
        />
      </TableCell>
      <TableCell>
        <UserStatusToggle
          userId={user.id}
          isActive={user.is_active !== false}
          onStatusChange={onStatusChange}
        />
      </TableCell>
      <TableCell className="text-right">
        <UserDeleteAction
          userId={user.id}
          onDeleteUser={onDeleteUser}
        />
      </TableCell>
    </TableRow>
  );
}
